import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import {
  Loading, Table, Card, Row, Col,
  Skeleton, Button, Page,
} from 'sha-el-design';
import { Colums } from 'sha-el-design/lib/components/Table/Table';

import { Inject } from '../../helpers';
import { AssignWorkNode, UserDetailNode, UserDetailNodeEdge } from '../../../schema';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { WorkHIstoryService } from '../../service/workHistoryService';
import { UserConsumer } from '../Common/UserContext';
import { renderCalendarFormat } from '../../helpers/date';
import { workStatusTag } from '../../helpers/status';
import { AssignWorkService } from '../../service/assignWorkService';
import { UserService } from '../../service/userService';
import { UserDetailDropdown } from '../Common/UserDetailDropdown';
import { workListQuery } from '../Calling/constant';
import { MdHome, MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';
import '../Common/listPageStyles';
import { AllocationCard } from '../Common/AllocationCard';

export class FinishedWorkList extends React.Component<{}, State> {
  @Inject workHistoryService: WorkHIstoryService;
  @Inject assignWorkService: AssignWorkService;
  @Inject userSerivce: UserService;

  afterStack = [];

  constructor(props: Readonly<{}>) {
    super(props);

    this.state = {
      offset: 0,
      name: '',
      currentPage: 1,
      updateCount: 0,
      user: null,
      caller: null,
    };
  }

  // BUG-08: singleton BehaviorSubject, subscription leaked on every unmount.
  private userSub: { unsubscribe: () => void } = null;

  componentDidMount() {
    this.userSub = this.userSerivce.user$.subscribe(
      (user) => this.setState({ user }),
    );
  }

  componentWillUnmount() {
    this.userSub && this.userSub.unsubscribe();
  }

  onNext = () => {
    let { currentPage, offset } = this.state;
    currentPage = currentPage + 1;
    offset = 20 * (currentPage - 1);
    this.setState({ currentPage, offset });
  }

  onPrev = () => {
    let { currentPage, offset } = this.state;
    if (currentPage === 1) {
      return;
    }
    else {
      currentPage = currentPage - 1;
      offset = 20 * (currentPage - 1);
      this.setState({ currentPage, offset });
    }
  }

  columns = (): Array<Colums<AssignWorkNode>> => {
    const cols: Array<Colums<AssignWorkNode>> = [{
      header: 'Employee',
      key: 'employee',
      render: (_, obj) => obj.caller.employee.name,
    }, {
      header: 'State',
      key: 'state',
      render: (_, obj) => obj.state.name,
    }, {
      header: 'Towns',
      key: 'towns',
      render: (_, obj) => obj.towns.map((v, i) => (
        <Row key={i}>
          <Col span={20}>{v.name}: {v.retailerCount}</Col>
        </Row>
      )),
    }, {
      header: 'Areas',
      key: 'areas',
      render: (_, obj) => obj.areas.map((v, i) => (
        <Row key={i}>
          <Col span={20}>{v.name}: {v.retailerCount}</Col>
        </Row>
      )),
    }, {
      header: 'Assignment Date',
      key: 'assignmentDate',
      render: (_, obj) => (
        <div>{renderCalendarFormat(obj.dateAssigned)}</div>
      ),
    }, {
      header: 'DeadLine',
      key: 'deadline',
      render: (_, obj) => <div>
        {renderCalendarFormat(obj.deadline)}
      </div>,
    }, {
      header: 'Status',
      key: 'status',
      render: (_, obj) => workStatusTag(obj.workStatus),
    }];

    return cols;
  }

  breadcrumbs = () => ({
    seperator: "/",
    paths: [
      { text: <MdHome />, link: "/dashboard" },
      { text: "Assign Work", link: "/dashboard/assign_work" },
      { text: "Finished Work List", link: "/dashboard/assign_work/finished_work" }
    ].map(v => ({
      render: () => (
        <Link key={v.link} to={v.link}>
          {v.text}
        </Link>
      )
    }))
  });
  
  render() {
    const { offset, currentPage, caller, user } = this.state;
    return (
      <div className='cs-list'>
        <Skeleton
          isLoading={false}
          render={() => (
            <Page
              title={"Finished Work List"}
              breadcrumbs={this.breadcrumbs()}
              backIcon={
                <Link to={"/dashboard/assign_work"}>
                  <MdArrowBack />
                </Link>
              }
        >
            <Card>
              {[
                <UserConsumer key='query'>
                  {({ id, areas, towns, states }) => (
                    <GraphqlQuery
                      queryString={workListQuery}
                      variables={{
                        offset,
                        caller: nestedAccess(caller, 'node', 'id'),
                        isFinished: true,
                        areas,
                        towns,
                        states,
                      }}
                      render={(response: { finishedFilterAssignWork: AssignWorkNode[] }, error, loading) => {
                        if (error) {
                          return <h3>Something went wrong</h3>;
                        }
                        return (
                          <Loading
                            isLoading={loading}
                            render={() => (
                              <Row justifyContent='flex-end'>
                                <Col span={24}>
                                  <div className='cs-list__filters'>
                                    <div className='cs-list__filter'>
                                      <UserDetailDropdown
                                        mode='single'
                                        value={caller}
                                        onChange={(v) => this.setState({ caller: v })}
                                        uniqueIdentifier={(v) => v && v.node.id}
                                        displayProp={(v) => v && v.node.employee.name || ''}
                                        label='Filter by caller'
                                        inputProps={{ required: true }}
                                        userType='CALLER'
                                        supervisorId={user.userType === 'SUPERVISOR' && user.id}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col>
                                  {/* Read-only card view: no per-location
                                      action and no reassignment here. */}
                                  {response.finishedFilterAssignWork.length ? (
                                    <div className='cs-grid'>
                                      {response.finishedFilterAssignWork.map((work) => (
                                        <AllocationCard key={work.id} work={work} />
                                      ))}
                                    </div>
                                  ) : (
                                    <div className='cs-list__empty'>
                                      <h4>
                                        {currentPage > 1 ? 'No more finished work' : 'No finished work yet'}
                                      </h4>
                                      <p>
                                        {currentPage > 1
                                          ? 'You have reached the end of the list.'
                                          : 'Allocations appear here once a caller finishes them.'}
                                      </p>
                                    </div>
                                  )}
                                  <div className='cs-list__pager'>
                                    <span className='cs-list__pager-info'>
                                      {response.finishedFilterAssignWork.length
                                        ? `Showing ${offset + 1}-${offset + response.finishedFilterAssignWork.length}`
                                        : ''}
                                    </span>
                                    <button
                                      type='button'
                                      className='cs-list__page-btn'
                                      onClick={this.onPrev}
                                      disabled={currentPage === 1}
                                    >
                                      Prev
                                    </button>
                                    <span className='cs-list__page-current'>{currentPage}</span>
                                    <button
                                      type='button'
                                      className='cs-list__page-btn'
                                      onClick={this.onNext}
                                      disabled={!response.finishedFilterAssignWork.length
                                        || response.finishedFilterAssignWork.length < 20}
                                    >
                                      Next
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          />
                        );
                      }}
                    />
                  )}
                </UserConsumer>,
              ]}
            </Card>
            </Page>
          )}
        />
      </div>
    );
  }
}

interface State {
  offset: number;
  name: string;
  currentPage: number;
  updateCount: number;
  user: UserDetailNode;
  caller: UserDetailNodeEdge;
}
